import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62eb1afa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid page min-h-100" }
const _hoisted_2 = { class: "page__content d-flex flex-column justify-content-between min-h-100" }
const _hoisted_3 = { class: "page__header" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "asahi-logo-header" }
const _hoisted_6 = { class: "d-flex align-items-center justify-content-end primary-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiLogoNew = _resolveComponent("AsahiLogoNew")!
  const _component_AsahiLanguageSelector = _resolveComponent("AsahiLanguageSelector")!
  const _component_AsahiButton = _resolveComponent("AsahiButton")!
  const _component_BreadcrumbLayout = _resolveComponent("BreadcrumbLayout")!
  const _component_AsahiBsFooter = _resolveComponent("AsahiBsFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("header", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "asahi-logo-header asahi-logo-pl-ePartnerKp clickable",
              onClick: _cache[0] || (_cache[0] = () => _ctx.$navigate('/'))
            }),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_AsahiLogoNew, {
                onClick: _cache[1] || (_cache[1] = () => _ctx.$navigate('/'))
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (!!_ctx.activeLanguage && _ctx.isInLoginPage)
              ? (_openBlock(), _createBlock(_component_AsahiLanguageSelector, {
                  key: 0,
                  languages: _ctx.languages,
                  activeLanguage: _ctx.activeLanguage,
                  onLanguagechange: _cache[2] || (_cache[2] = (event) => _ctx.changeLanguage(event))
                }, null, 8, ["languages", "activeLanguage"]))
              : _createCommentVNode("", true),
            (!_ctx.isOnForgotPassword)
              ? (_openBlock(), _createBlock(_component_AsahiButton, {
                  key: 1,
                  type: "primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToLoginPage('/login'))),
                  class: "login-button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Login')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_BreadcrumbLayout, { class: "mt-5 pt-5" }),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_AsahiBsFooter, {
          onLanguagechange: _ctx.changeLanguage,
          language: _ctx.languages,
          "active-language": _ctx.activeLanguage,
          user: _ctx.user,
          "footer-data": _ctx.portalPageMenuLink,
          "brand-data": _ctx.footerLinksBrands,
          "header-data": _ctx.portalPageMenuLink,
          cookies: _ctx.footerLinksCookies,
          "terms-of-use": _ctx.footerLinksTermsOfUse,
          "privacy-policy": _ctx.footerLinksPrivacyPolicy
        }, null, 8, ["onLanguagechange", "language", "active-language", "user", "footer-data", "brand-data", "header-data", "cookies", "terms-of-use", "privacy-policy"])
      ])
    ])
  ]))
}